var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNotificationAlarm1 = function SvgNotificationAlarm1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 14"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.933 9v.525c0 .391.155.767.432 1.043.276.277.744.432 1.135.432H.5c.391 0 .859-.155 1.135-.432.277-.276.432-.652.432-1.043v-3.6A3.933 3.933 0 0 1 7 2.12M10.019.5v3M5 13.5h2M10.019 5.75a.25.25 0 1 1 0-.5M10.019 5.75a.25.25 0 0 0 0-.5"
  }))));
};
export default SvgNotificationAlarm1;